import { ccMediumGray, white } from "@styles/synchrony-core-palette.js";

const SvgIconRefresh = (props) => {
  const {
    width = 20,
    height = 20,
    enableViewBox = true,
    iconFillColor = ccMediumGray,
    outerFillColor = "none",
    iconBackgroundFillColor = white,
    onClick,
    ...otherProps
  } = props;

  return (
    <svg
      width={width}
      height={width}
      {...(enableViewBox && { viewBox: `0 0 ${width} ${height}` })}
      {...otherProps}
      onClick={onClick}
    >
      <defs>
        <path
          id="refresh_prefix__a"
          d="M18.99 10.899c-.217 4.13-3.806 7.31-8 7.091a.732.732 0 01-.707-.772.733.733 0 01.784-.695c3.373.177 6.258-2.381 6.433-5.702.174-3.321-2.428-6.167-5.801-6.343C8.326 4.3 5.44 6.86 5.266 10.18l-.04.762 1.579-1.4a.742.742 0 011.06.056.68.68 0 01.198.523.73.73 0 01-.252.5l-3.456 3.064-3.157-3.411A.73.73 0 011 9.742c.01-.194.1-.375.253-.51a.756.756 0 01.541-.195c.197.01.38.1.518.25l1.424 1.557.039-.742c.217-4.13 3.805-7.31 8-7.091 4.194.22 7.43 3.758 7.214 7.888z"
        />
      </defs>
      <g fill={outerFillColor} fillRule="evenodd">
        <mask id="refresh_prefix__b" fill={iconBackgroundFillColor}>
          <use xlinkHref="#refresh_prefix__a" />
        </mask>
        <use
          fill={iconFillColor}
          fillRule="nonzero"
          xlinkHref="#refresh_prefix__a"
        />
        <path
          fill={`${iconFillColor} !important`}
          mask="url(#refresh_prefix__b)"
          d="M0 0h20v20H0z"
        />
      </g>
    </svg>
  );
};

export default SvgIconRefresh;
